import { v4 } from 'uuid';
import { dispatchRequestInfo, executeTwoStepEventQuery, exposeEvent } from './execute';
import fromUsersResult from '../converters/usersConverter';
import {
  buildUsersQuery,
  fromCsvUsersResponse,
  getUsersInfo,
} from '../converters/usersApiConverter';
import { downloadCsv } from '../utils/common';
import { TABS } from '../constants/navigation';

export const executeUsersQuery = (executeId) => (dispatch, getState) => {
  const query = buildUsersQuery(getState());
  return executeTwoStepEventQuery(query, executeId, dispatch, getState).then((response) => ({
    events: fromUsersResult(response, query),
  }));
};

export const executeUsersCsvQuery = () => (dispatch, getState) => {
  const state = getState();
  const query = buildUsersQuery(state);
  const executeId = v4();
  const usersInfo = getUsersInfo(state);

  dispatchRequestInfo(executeId, dispatch, TABS.USERS.title, [query.eventName], true);

  return executeTwoStepEventQuery(query, executeId, dispatch, getState)
    .then((response) => fromCsvUsersResponse(response, query, usersInfo))
    .then(downloadCsv);
};

export const exposeUsersQuery = () => (dispatch, getState) => {
  const query = buildUsersQuery(getState());
  return exposeEvent(query, v4(), dispatch, getState).then((response) => ({
    sql: response,
  }));
};
